import React from 'react';
import {connect} from "react-redux";
import {Container, Grid, GridRow, Menu, Responsive, Segment} from "semantic-ui-react";
import CancelModal from "./anualOpenEnrollment/cancelModal";
import {currentYear} from "../utils/date";
import axios from "axios";
import {setFooter} from "../actions/footerActions";
import STRATEGIC_PARTNER from "../constants/strategicPartners";


const rightsReservedCopy = `©${currentYear()} Renaissance Holding Company. All Rights Reserved.`;
const privacyPolicyUrl = STRATEGIC_PARTNER.LEGAL.PRIVACY;
const termsUrl = STRATEGIC_PARTNER.LEGAL.TERMS;

const mapStateToProps = ({footer, auth, anualOpenEnrollment}, ownProps) => {
    return {
        authToken: auth?.loginInfo?.authToken,
        showCancelAOEFlowModal: anualOpenEnrollment.showCancelAOEFlowModal,
        carrierDisclaimers: footer.carrierDisclaimer?.split('\n') || [],
        ...ownProps
    }
};

const Footer = ({button, showTopFooter, link, hasToDisplayCarrierDisclaimer, carrierDisclaimers,
                    showCancelAOEFlowModal, largeButton, authToken, dispatch}) => {
    const isLoggedin = authToken || false;

    const hasCarrierDisclaimers = React.useCallback(() => !!carrierDisclaimers.length, [carrierDisclaimers]);

    const displayCarrierDisclaimer = isLoggedin && hasToDisplayCarrierDisclaimer && hasCarrierDisclaimers();

    React.useEffect(() => {
        const fetchFooterData = () => {
            if (hasToDisplayCarrierDisclaimer && !hasCarrierDisclaimers()) {
                axios.post("/api/member/v2/getFooter", null).then(({data}) => {
                    dispatch(setFooter(data))
                });
            }
        }
        fetchFooterData();
    }, [hasToDisplayCarrierDisclaimer]);

    return (
        <React.Fragment>
            {showCancelAOEFlowModal && <CancelModal/>}
            <div className="footer">
                {showTopFooter &&
                    <div className={"buttonContainer"}>
                        <Container>
                            <Grid columns={3} verticalAlign={"middle"}>
                                <Grid.Column width={!!largeButton? 4 : 5}/>
                                <Grid.Column width={ !!largeButton ? 4 : 2}>
                                    {button}
                                </Grid.Column>
                                <Grid.Column width={!!largeButton? 4 : 5} textAlign={"left"}>
                                    {!!link && link}
                                </Grid.Column>
                            </Grid>
                        </Container>
                    </div>
                }
                <Responsive as={Container} fluid minWidth={Responsive.onlyComputer.minWidth}>
                    <Grid columns={'equal'}>
                        <Grid.Column>
                            <Menu text>
                                <Menu.Item>
                                    {rightsReservedCopy}
                                </Menu.Item>
                            </Menu>
                        </Grid.Column>
                        <Grid.Column>
                            <Menu text className={'termsPrivacy'}>
                                <Menu.Menu position="right">
                                    <Menu.Item as="a" href={termsUrl} target="_blank">
                                        Terms
                                    </Menu.Item>
                                    <Menu.Item as="a" href={privacyPolicyUrl} target="_blank">
                                        Privacy
                                    </Menu.Item>
                                </Menu.Menu>
                            </Menu>
                        </Grid.Column>
                    </Grid>
                    { displayCarrierDisclaimer &&
                        <GridRow>
                            { carrierDisclaimers?.map((paragraph, index) =>
                                (<p key={index} className={'carrierDisclaimers'}>{paragraph}</p>))}
                        </GridRow>
                    }
                </Responsive>
                <Responsive as={Segment} basic maxWidth={Responsive.onlyComputer.minWidth - 1} className={'dispositives'}>
                    { displayCarrierDisclaimer &&
                        <p className={"neutral700Text carrierDisclaimers"}>
                            { carrierDisclaimers?.map((paragraph, index) =>
                                (<React.Fragment key={index}><span>{paragraph}</span><br/></React.Fragment>))
                            }
                        </p>
                    }
                    <p className={"neutral700Text"}>{rightsReservedCopy}</p>
                    <p>
                        <a style={{paddingRight: '1em'}} className={"neutral500Text"} href={privacyPolicyUrl}  target="_blank" rel="noopener noreferrer">
                            <b>Privacy</b>
                        </a>
                        <a className={"neutral500Text"}  href={termsUrl}  target="_blank" rel="noopener noreferrer">
                            <b>Terms</b>
                        </a>
                    </p>
                </Responsive>
            </div>
        </React.Fragment>
    )
}

export default connect(mapStateToProps)(Footer);
